// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__7zXof","links":"styles_links__m+dv9"};